import { Icon, IconComponent } from '@graftcode/design-system'

import { SearchHighlightedSnippet } from '../SearchHighlightedSnippet'

import styles from '../../SearchModal.module.scss'

type SearchRowBodyProps = {
  title: string
  metaTag: string | null
  titleTag?: string
  badge?: string
  feedLabel?: string
  feedPrivate?: boolean
  statusLabel?: string
  statusTone?: string
  teaserRaw: string
  query: string
}

export function SearchRowBody({
  title,
  metaTag,
  titleTag,
  badge,
  feedLabel,
  feedPrivate,
  statusLabel,
  statusTone,
  teaserRaw,
  query,
}: SearchRowBodyProps) {
  const metaWithoutStatus =
    statusLabel && teaserRaw.startsWith(`${statusLabel} • `)
      ? teaserRaw.slice(statusLabel.length + 3)
      : statusLabel && teaserRaw === statusLabel
        ? ''
        : teaserRaw

  return (
    <span className={styles.itemBody}>
      <span className={styles.itemTitleRow}>
        <span className={styles.itemTitle}>{title}</span>
        {titleTag ? <span className={styles.titleTag}>{titleTag}</span> : null}
        {badge ? <span className={styles.packageBadge}>{badge}</span> : null}
        {feedLabel ? (
          <span className={styles.feedLabel}>
            {feedPrivate ? <IconComponent icon={Icon.LockClosedRegular} size={16} /> : null}
            {feedLabel}
          </span>
        ) : null}
        {metaTag !== null ? <span className={styles.metaTag}>{metaTag}</span> : null}
      </span>

      {statusLabel ? (
        <span className={styles.statusMeta}>
          <span className={styles.statusGroup}>
            <span className={styles.statusDot} data-tone={statusTone ?? 'muted'} />
            <span className={styles.statusLabel}>{statusLabel}</span>
          </span>
          {metaWithoutStatus ? (
            <>
              <span className={styles.metaBullet} aria-hidden>
                •
              </span>
              <span className={styles.shortDesc}>
                <SearchHighlightedSnippet
                  snippet={metaWithoutStatus}
                  query={query}
                  highlightClassName={styles.highlight ?? ''}
                />
              </span>
            </>
          ) : null}
        </span>
      ) : teaserRaw !== '' ? (
        <span className={styles.shortDesc}>
          <SearchHighlightedSnippet snippet={teaserRaw} query={query} highlightClassName={styles.highlight ?? ''} />
        </span>
      ) : null}
    </span>
  )
}
